import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { library, IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faEdit,
  faExclamationTriangle,
  faSpinner,
  faUserCircle,
  faFilter,
  faExternalLinkAlt,
  faSync,
  faArrowRight,
  faInfoCircle,
  faCheck,
  faCheckSquare,
  faSearch,
  faLock,
  faTimes,
  faBan,
  faChevronLeft,
  faChevronRight,
  faArrowAltCircleRight,
  faShoppingBasket,
  fas,
} from '@fortawesome/free-solid-svg-icons';

import {
  faFile,
  faSquare,
  faQuestionCircle,
  far,
} from '@fortawesome/free-regular-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { MatIconRegistry } from '@angular/material/icon';

interface MaterialIcon {
  name: string;
  url: any;
}

@Injectable()
export class IconsHelper {
  private faIcons: IconDefinition[] = [
    faEdit,
    faExclamationTriangle,
    faFile,
    faSpinner,
    faUserCircle,
    faFilter,
    faExternalLinkAlt,
    faSync,
    faArrowRight,
    faCheck,
    faCheckSquare,
    faSearch,
    faSquare,
    faLock,
    faTimes,
    faBan,
    faChevronLeft,
    faChevronRight,
    faArrowAltCircleRight,
    faQuestionCircle,
    faInfoCircle,
    faShoppingBasket,
  ];

  private materialIcons: MaterialIcon[] = [
    {
      name: 'arrow-down',
      url: 'assets/images/icons/icon-arrow-down.svg',
    },
    {
      name: 'close',
      url: 'assets/images/icons/icon-close.svg',
    },
    {
      name: 'dropdown',
      url: 'assets/images/icons/icon-dropdown.svg',
    },
    {
      name: 'menu-expansion',
      url: 'assets/images/icons/icon-menu-expansion.svg',
    },
    {
      name: 'submenu-expansion',
      url: 'assets/images/icons/icon-submenu-expansion.svg',
    },
    {
      name: 'menu',
      url: 'assets/images/icons/icon-menu.svg',
    },
    {
      name: 'ecp-arrow-left',
      url: 'assets/images/icons/icon-arrow-left.svg',
    },
    {
      name: 'ecp-arrow-right',
      url: 'assets/images/icons/icon-arrow-right.svg',
    },
    {
      name: 'ecp-scroll-down',
      url: 'assets/images/icons/icon-scroll-down.svg',
    },
    {
      name: 'ecp-play',
      url: 'assets/images/icons/icon-play.svg',
    },
    {
      name: 'ecp-play-dark',
      url: 'assets/images/icons/icon-play-dark.svg',
    },
    {
      name: 'icon-down-arrow',
      url: 'assets/images/icons/icon-down-arrow.svg',
    },
    {
      name: 'icon-up-arrow',
      url: 'assets/images/icons/icon-up-arrow.svg',
    },
  ];

  constructor(
    private iconReg: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private faLibrary: FaIconLibrary,
  ) {}

  installIcons(): void {
    this.faLibrary.addIconPacks(fas);
    this.faLibrary.addIconPacks(far);
    this.faLibrary.addIcons(...this.faIcons);

    library.add(...this.faIcons);

    this.materialIcons.forEach(({ name, url }) => {
      this.iconReg.addSvgIcon(
        name,
        this.sanitizer.bypassSecurityTrustResourceUrl(url),
      );
    });
  }
}
